import '../assets/stylesheets/header.css';
import {Link} from 'react-router-dom';
export default function Header(){


    
    function hideMenu(){
        const closemenu = document.querySelector("div.mobilemenu");
        closemenu.classList.remove('showmenu'); 
    }

    function showMenu(){
        const closemenu = document.querySelector("div.mobilemenu");
        closemenu.classList.add('showmenu'); 
    }


    return (


        <header>
            <div className="mobilemenu">
                <img id='logo' alt='Abigail Gordon Logo' src={require('../assets/images/logo_2.png')} />
                <h3>Menu</h3>
                <li className="menucombo"><img src={require('../assets/icons/home.png')} alt="home icon" className="menuicon" /> <Link to='/'> Home</Link> </li>
                <li className="menucombo"><img src={require('../assets/icons/about.png')} alt="about icon" className="menuicon" /> <Link to='/about'>About</Link> </li>
                <li className="menucombo"> <img src={require('../assets/icons/shopping-cart.png')} alt="preoder icon" className="menuicon" /><Link to='/preorder'>Order</Link> </li>
                <li onClick={hideMenu} id="closemenu" className="menucombo"><img src={require('../assets/icons/close.png')} alt="close menu icon" className="menuicon" /> <Link >Close Menu</Link></li>
            </div>
            <nav id="socialnav">
                <li onClick={showMenu} id="menuicon"><img className='social' alt='menu icon' src={require('../assets/icons/menu.png')} /></li>
                <li><img className='social' alt='Abigail Gordon Facebook Page' src={require('../assets/icons/facebook.png')} /></li>
                <li><img className='social' alt='Abigail Gordon Instagram Page' src={require('../assets/icons/instagram.png')} /></li>
                <li><img className='social' alt='Abigail Gordon TikTok Page' src={require('../assets/icons/tik-tok.png')} /></li>
            </nav>
            <section id="logonavcombo">
                <img id='logo' alt='Abigail Gordon Logo' src={require('../assets/images/logo_2.png')} />
                <nav id="primarynav">
                    <li className="menucombo"> <img src={require('../assets/icons/home.png')} alt="home icon" className="menuicon" /> <Link to='/'> Home</Link> </li>
                    <li className="menucombo"> <img src={require('../assets/icons/about.png')} alt="about icon" className="menuicon" /> <Link to='/about'>About</Link> </li>
                    <li className="menucombo"> <img src={require('../assets/icons/shopping-cart.png')} alt="preoder icon" className="menuicon" /><Link to='/preorder'>Order</Link> </li>
                </nav>
            </section>
        </header>
    );

}